import { Component } from '@angular/core';
import { environment } from '@environments/environment';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { register } from 'swiper/element/bundle';

register();
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [IonApp, IonRouterOutlet, TranslateModule],
})
export class AppComponent {
  constructor() {}
  ngOnInit() {
    //console.log('App initialized with environment:', environment.env);
    //console.log('API URL:', environment.apiUrl);
  }
}
